import { type } from "../../types/types";

export default function reducer(state = { users: [], pagination: {} }, action) {
  switch (action.type) {
    case type.SET_USERS:
      return { ...state, ...action.users };
    default:
      return state;
  }
}
